import { useContext } from 'react';
import { Modal } from "react-bootstrap";
import { AddFileNavigationPositionEnum } from '../../../../domain/enum/AddFileNavigationPosition';
import { AddImageModalContext } from '../context/AddImageModalContext';

export const AddImageModalTitle = () => {
    const {
        navigationPosition,
    } = useContext(AddImageModalContext);

    switch (navigationPosition) {
        case AddFileNavigationPositionEnum.index: {
            return (
                <Modal.Title>
                    Escolher Imagem
                </Modal.Title>
            );
        }
        case AddFileNavigationPositionEnum.sendFile: {
            return (
                <Modal.Title>
                    <span>Escolher Imagem {">"}</span> Enviar Arquivo
                </Modal.Title>
            );
        }
        case AddFileNavigationPositionEnum.sendLink: {
            return (
                <Modal.Title>
                    <span>Escolher Imagem {">"}</span> Enviar da internet
                </Modal.Title>
            );
        }
        default:
            return <></>;
    }
};
